import firebase from "firebase/app"
import 'firebase/auth'
import 'firebase/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyDIpOPo5yppZPJF_Rn4mCZpw6pjT89YXjs",
    authDomain: "manibarathi-3b4e9.firebaseapp.com",
    projectId: "manibarathi-3b4e9",
    storageBucket: "manibarathi-3b4e9.appspot.com",
    messagingSenderId: "329855807879",
    appId: "1:329855807879:web:ebbebdbc7c301e044ba322"
}

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig)
}

export const db = firebase.firestore()
export const auth = firebase.auth()

export const getTimestamp = () => firebase.firestore.FieldValue.serverTimestamp()